import React from 'react';

const WithLessOutsideIcon = () => (
  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="11.5" y="6.69336" width="11.4999" height="4.59997" fill="#B5B8BF"/>
    <rect y="13.6133" width="11.4999" height="4.59997" fill="#B5B8BF"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.75 12.5L5.75 1.00007H10.35V12.5H5.75Z" fill="#B5B8BF"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M12.6504 24L12.6504 12.5001H17.2504V24H12.6504Z" fill="#B5B8BF"/>
    <rect x="20.582" y="0.790978" width="2.5" height="28.334" transform="rotate(45 20.582 0.790978)" fill="#9CA1AA"
          stroke="#F8F8F8" strokeWidth="0.5"/>
  </svg>
);

export default WithLessOutsideIcon;
